<style lang="scss" scoped>
@import "../../sass/variables.scss";

.main-point-box {
  background-color: #fff;
}

.list-title {
  gap: 24px;
}

.list-number {
  width: 48px;
  height: 48px;
  background: $primary;
}


svg g {
  fill: #fff;
}
</style>

<template>
  <div>

    <div class="row mb-60 mb-lg-6">
      <div v-for="item in list" class="col-12 col-xl-4 mb-25 mb-last-0">
        <div class="main-point-box p-25">
          <div class="d-flex list-title w-100 mb-32">
              <div class="list-number">
                <component v-for="char in item['wpcf-priority']" :is="`number-${char}`" :key="char" color="#F5C7CB"></component>
              </div>
            <p class="text-primary font-weight-extrabold mb-0 fs-28" v-html="item.title.rendered"></p>
          </div>


            <VueReadMoreSmooth :no-button="true" :open="open" :no-shadow="true" :lines="14">

              <p class="text-gray fs-20 "
                v-html="item.description"
              />
            </VueReadMoreSmooth>


          <button @click.prevent="toggle" class="btn-rounded mt-32 btn btn-primary fs-20 py-2 px-5 ff-ub-r">
            <span class="mr-3" v-html="open ? 'Lees minder' : 'Lees meer'"></span>
            <svg v-if="!open" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.16699 6.83335H0.166992V5.16669H5.16699V0.166687H6.83366V5.16669H11.8337V6.83335H6.83366V11.8334H5.16699V6.83335Z" fill="#D9E3E2"/>
            </svg>
            <svg v-else width="12" height="12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D9E3E2">
              <path  d="M5 12h14" />
            </svg>


          </button>
        </div>
      </div>
   </div>
  </div>
</template>

<script>
import VueReadMoreSmooth from "vue-read-more-smooth";

export default {
  props: ["data"],

  components: { VueReadMoreSmooth },

  data() {
    return {
      list: [],
      open: false,
    };
  },
  created() {
    this.list = this.data;
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MainPointsComponent.vue